<div class="sw-cms-block-moorl-grid-layout-fourteen">
    <slot name="slot-a"></slot>
    <slot name="slot-b"></slot>
    <slot name="slot-c"></slot>
</div>